import React from 'react';
import EditSectionInput from './EditSectionInput';
import moment from 'moment';
import Datetime from 'react-datetime';
import Alerts from '../prototypes/Alerts';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
//This augments the moment object but it has to be imported to work
//eslint-disable-next-line
import tz from 'moment-timezone';

//moment.tz.setDefault("America/Los_Angeles");

class EditSectionDatetime extends React.Component {
  constructor( props ) {
    super( props );

    // Focus ref
    this.EditSectionDatetimeRef = React.createRef();
    this.EditSectionSelectableClassName = 'datetime_' + ( Math.random().toString( 36 ).substring( 7 ) );
    this.momentFormat = this.props.dateFormat ? this.props.dateFormat : 'YYYY-MM-DD';
    this.momentFormat += this.props.timeFormat ? ` ${this.props.timeFormat}` : '';

    // Component state
    this.state = {
      columnName: this.props.columnName === undefined ? '' : this.props.columnName,
      value: this.props.value === undefined ? moment() : this.props.value,
      disabled: this.props.disabled === undefined ? false : this.props.disabled,
      timeFormat: this.props.timeFormat === undefined ? false : this.props.timeFormat,
      dateFormat: this.props.dateFormat === undefined ? 'YYYY-MM-DD' : this.props.dateFormat,
      localValue: this.props.value === undefined ? 'today' : this.props.value,
      height: this.props.height === undefined ? 'auto' : this.props.height,
      width: this.props.width === undefined ? 'auto' : this.props.width,
      readonly: this.props.readonly === undefined ? false : this.props.readonly,
      focus: this.props.focus === undefined ? false : this.props.focus,
      hasError: false,
      error: {},
      info: {}
    };

    this.onChange = this.onChange.bind( this );
    this.onBlur = this.onBlur.bind( this );
    this.timerFocusEvent = this.timerFocusEvent.bind( this );
    this.renderInput = this.renderInput.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentDidMount() {
    if ( typeof ( this.state.value ) === 'number' ) {
      let formattedDate = this.formatDate( this.state.value );
      this.setState( { value: formattedDate, localValue: formattedDate } );

      // String values will now update the current item (parent)
    } else if ( typeof ( this.state.value ) === 'string' ) {
      if ( this.state.value === 'today' || this.state.value === 'yesterday' || ( this.state.value ).toLowerCase().indexOf( 'from' ) !== -1 ) {
        let formattedDate = this.formatDate( this.state.value );
        this.setState( { value: formattedDate, localValue: formattedDate }, () => this.onChange( formattedDate ) );
      } else {
        this.onChange( this.state.value );
      }
    }

    // Focuses component forcing it to show the calendar
    if ( this.props.focus === true || this.state.focus === true ) {

      // Using the React 16.3 or higher
      if ( this.EditSectionDatetimeRef.current && this.EditSectionDatetimeRef.current.focus ) {
        this.EditSectionDatetimeRef.current.focus();

        // Different way to focus React version less than 16.3, ref's do not seem to work for loadable components.
        // Right now using a random hash class to focus on the element works, but I can see this having short comings
        // this is handled by a callback
      } else {
        window.setTimeout( this.timerFocusEvent, 100 );
      }
    }
  }

  componentWillReceiveProps( nextProps ) {
    if ( nextProps.value !== this.state.value ) {
      let formattedDate = this.formatDate( nextProps.value );
      this.setState( {
        value: formattedDate,
        localValue: formattedDate,
        timeFormat: nextProps.timeFormat,
        dateFormat: nextProps.dateFormat,
        height: nextProps.height === undefined ? 'auto' : nextProps.height,
        width: nextProps.width === undefined ? 'auto' : nextProps.width,
        readonly: nextProps.readonly === undefined ? false : nextProps.readonly,
        focus: nextProps.focus === undefined ? false : nextProps.focus
      } );
    }
  }

  // Cleans the component on it being unmounted
  componentWillUnmount() {
    this._ismounted = false;
    if ( this.updateTrigger !== undefined ) {
      window.clearTimeout( this.timerFocusEvent );
    }
  }

  // Event to focus the input and make the calendar pop come up on input focus.
  timerFocusEvent() {
    let element = document.getElementsByClassName( this.EditSectionSelectableClassName );

    if ( element.length !== 0 ) {
      element = element[ 0 ];
      if ( element ) {
        const inputElement = element.querySelector( 'input' );
        if ( inputElement ) {
          inputElement.focus();
          window.clearTimeout( this.timerFocusEvent );
        }
      }
    }
  }

  /*
    Function for dealing with higher order special constructs.
    Including:
    'today'
    'yesterday'
    'from' example: '5 months from today' or '6 days from 2018-04-22'
  */
  formatDate( currentDate ) {
    // Checks to see if 'today' was asked for
    let formattedDate = moment( currentDate );
    let timeFormat = this.state.timeFormat === false ? '' : ' ' + this.state.timeFormat;
    if ( moment.isMoment( currentDate ) === true ) {
      if ( moment( currentDate ).isValid() ) {
        if ( this.state.dateFormat && this.state.timeFormat === false ) {
          formattedDate = moment( currentDate ).format( this.state.dateFormat );

          //DATETIME
        } else if ( this.state.dateFormat && this.state.timeFormat !== false ) {
          formattedDate = moment( formattedDate ).format( this.state.dateFormat + ' ' + this.state.timeFormat );
        }

        //Convert it to a swell time string
        if ( !this.state.dateFormat && this.state.timeFormat ) {
          formattedDate = moment( formattedDate ).format( this.state.timeFormat );
        }
      }

    } else if ( typeof ( currentDate ) === 'string' ) {
      if ( currentDate.toLowerCase() === 'today' ) {
        // Set the date
        formattedDate = moment().tz( 'America/Los_Angeles' ).format( this.state.dateFormat + timeFormat );
        let e = {};
        e[ 'target' ] = this;
        e[ 'target' ][ 'value' ] = formattedDate;
        // Notify the parent
        this.props.onChange( e );
        return formattedDate;
      } else if ( currentDate.toLowerCase() === 'yesterday' ) {
        // Set the date to yesterday
        formattedDate = moment().tz( 'America/Los_Angeles' ).subtract( 1, 'days' ).format( this.state.dateFormat + timeFormat );
        // Notify the parent
        let e = {};
        e[ 'target' ] = this;
        e[ 'target' ][ 'value' ] = formattedDate;
        this.props.onChange( e );
        return formattedDate;
      } else if ( currentDate.toLowerCase().indexOf( 'from' ) !== -1 ) {

        let split_array = currentDate.split( ' ', 4 );

        if ( split_array.length === 4 ) {
          let countUnit = parseInt( split_array[ 0 ].trim(), 10 );
          let unit = split_array[ 1 ].trim();
          let preposition = split_array[ 2 ].trim();

          //Lets assume the rest of the string is the date, so we are going to "subtract"
          //the rest of the string from it
          let subtractor = countUnit + ' ' + unit + ' ' + preposition + ' ';

          let extractDate = currentDate.replace( subtractor, '' ).trim();


          //Check if the count is a number
          if ( Number.isInteger( countUnit ) ) {
            if ( extractDate === 'today' ) {
              extractDate = moment().format( this.state.dateFormat + timeFormat );
            }

            if ( extractDate === 'yesterday' ) {
              extractDate = moment().subtract( 1, 'days' ).format( this.state.dateFormat + timeFormat );
            }

            if ( moment( extractDate ).isValid() ) {
              formattedDate = moment( extractDate ).tz( 'America/Los_Angeles' ).add( countUnit, unit ).format( this.state.dateFormat + timeFormat );
            } else {
              formattedDate = moment().tz( 'America/Los_Angeles' ).format( this.state.dateFormat + timeFormat );
            }
            let e = {};
            e[ 'target' ] = this;
            e[ 'target' ][ 'value' ] = formattedDate;
            this.props.onChange( e );
            return formattedDate;
          }


        }

      } else if ( formattedDate.isValid() === true ) {
        if ( this.state.dateFormat && this.state.timeFormat === false ) {
          formattedDate = moment( currentDate ).format( this.state.dateFormat );

          //DATETIME
        } else if ( this.state.dateFormat && this.state.timeFormat !== false ) {
          formattedDate = moment( formattedDate ).format( this.state.dateFormat + ' ' + this.state.timeFormat );
        }
      } else if ( formattedDate.isValid() === false && !this.state.dateFormat && this.state.timeFormat ) {
        //Time is valid but it isn't a valid DT
        formattedDate = currentDate;

      }
    } else if ( typeof ( currentDate ) === 'number' ) {
      if ( this.state.dateFormat && this.state.timeFormat === false ) {
        formattedDate = moment( currentDate.toString() ).format( this.state.dateFormat );
        //DATETIME
      } else if ( this.state.dateFormat && this.state.timeFormat !== false ) {
        formattedDate = moment( formattedDate.toString() ).format( this.state.dateFormat + ' ' + this.state.timeFormat );
      }
    }
    // Return the formatted value so the caller can set the state
    return formattedDate;
  }


  /* Parent function that triggers when the child component changes */
  onChange( newDateObj ) {
    // Get what is current in the input to check if user typed in a valid date
    let datetimeStringInput = newDateObj[ '_i' ] || newDateObj.toString();

    // Parse the input to the format it should be in strictly
    if ( moment( datetimeStringInput, this.momentFormat, true ).isValid() ) {
      let e = {};

      // It is a valid input, format the new date to how it should be shown
      datetimeStringInput = moment( newDateObj, this.momentFormat, true ).format( this.momentFormat );

      // Update myself and the parent of the changes
      e[ 'target' ] = this;
      e[ 'target' ][ 'value' ] = datetimeStringInput;

      this.setState( {
        localValue: datetimeStringInput
      }, () => {
        this.props.onChange( e );
      } );
    }
  }

  /**
   * Validate the input if it is a valid datetime when the user leaves the input.
   *
   * @param {moment|String} datetimeStringInput The updated datetime string.
   */
  onBlur( datetimeStringInput ) {
    if ( !moment( datetimeStringInput, this.momentFormat, true ).isValid() ) {
      const { dispatch, bugsnag } = this.props;
      const alerts = new Alerts( bugsnag, dispatch );

      alerts.WARNING( 'Datetime Error', `A datetime input was not valid. Format expected: ${this.momentFormat}.`, null );
    }
  }

  renderInput( props ) {
    const datepickerElement = document.getElementsByClassName( this.EditSectionSelectableClassName )[ 0 ];

    if ( datepickerElement ) {
      const rdtPicker = datepickerElement.getElementsByClassName( 'rdtPicker' )[ 0 ];
      const rdtDays = rdtPicker.getElementsByClassName( 'rdtDays' )[ 0 ];

      // Only prepend the Today button if it has not been created yet
      if ( rdtPicker.childElementCount === 1 ) {
        const today = () => {
          props.onChange( { target: { value: moment().tz( 'America/Los_Angeles' ).format( this.momentFormat ) } } );
        };

        const todayButton = document.createElement( 'button' );
        todayButton.innerHTML = 'Today';
        todayButton.className = 'form-control';
        todayButton.onclick = today;

        if( rdtDays ){
          rdtDays.parentNode.prepend( todayButton );
        }
      }

      return (
        <div>
          <input {...props} />
        </div>
      );
    }

    return null;
  }

  render() {
    let styles = {
      'width': this.props.width === undefined ? 'auto' : this.props.width,
      'height': this.props.height === undefined ? 'auto' : this.props.height,
      'fontSize': '100%',
    };

    let readonly = this.state.readonly;

    if ( this.state.hasError === false ) {

      if ( readonly === true ) {
        return (
          <EditSectionInput columnName='Date' value={this.state.value} readonly={readonly} visible="true" style={styles} />
        );
      } else if ( this.state.visible === 'false' ) {
        return (
          <div></div>
        );
      } else {
        let dateValue = this.state.localValue;
        //This exists because of a firefox bug where it leaks the moment object for some reason and it wont rerender after receiving that moment object
        //If this causes issues elsewhere talk to Branden HELP-3590
        if ( this.state.localValue._isAMomentObject !== undefined ) {
          dateValue = dateValue[ '_i' ];
        }

        return (
          <Datetime
            className={this.EditSectionSelectableClassName}
            style={styles}
            value={dateValue}
            onChange={this.onChange}
            onBlur={this.onBlur}
            timeFormat={this.state.timeFormat}
            dateFormat={this.state.dateFormat}
            displayTimeZone={'America/Los_Angeles'}
            renderInput={this.renderInput}
          />
        );
      }

    } else {
      return ( <div></div> );
    }
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user,
        google: store.google.ReactGA
      };
    }
  )( EditSectionDatetime ) );



// WEBPACK FOOTER //
// ./src/presentation/EditSectionDateTime.js